"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-people.tsx
var People = function People(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M13.333 9.16663C14.7163 9.16663 15.8247 8.04996 15.8247 6.66663C15.8247 5.28329 14.7163 4.16663 13.333 4.16663C11.9497 4.16663 10.833 5.28329 10.833 6.66663C10.833 8.04996 11.9497 9.16663 13.333 9.16663ZM6.66634 9.16663C8.04967 9.16663 9.15801 8.04996 9.15801 6.66663C9.15801 5.28329 8.04967 4.16663 6.66634 4.16663C5.28301 4.16663 4.16634 5.28329 4.16634 6.66663C4.16634 8.04996 5.28301 9.16663 6.66634 9.16663ZM6.66634 10.8333C4.72467 10.8333 0.833008 11.8083 0.833008 13.75V15.8333H12.4997V13.75C12.4997 11.8083 8.60801 10.8333 6.66634 10.8333ZM13.333 10.8333C13.0913 10.8333 12.8163 10.85 12.5247 10.875C13.4913 11.575 14.1663 12.5166 14.1663 13.75V15.8333H19.1663V13.75C19.1663 11.8083 15.2747 10.8333 13.333 10.8333Z",
    fill: "currentColor"
  }));
};

var _default = People;
exports.default = _default;